// applies tailwind themes using css variables
import type React from 'react';

import { observer } from 'mobx-react';

import useTheme from './hooks/theme';
import { defaultTheme, useBzThemeStore } from './store/theme';
import type { ITheme } from './store/theme';

export interface IProps {
  theme?: Partial<ITheme>;
}

const BzTheme: React.FC<IProps> = observer((props) => {
  useTheme(props.theme ?? defaultTheme);

  return null;
});

export const BzChangableTheme: React.FC = observer(() => {
  const { theme } = useBzThemeStore();
  useTheme(theme ?? defaultTheme);

  return null;
});

export default BzTheme;
